export default __webpack_public_path__ + "static/media/search.9957e8a9.svg";